module.exports = __webpack_public_path__ + "static/media/sc_7_i.12f2e61f.png";